import { render, staticRenderFns } from "./EmailVerifiedView.vue?vue&type=template&id=3ffef50a&scoped=true"
import script from "./EmailVerifiedView.vue?vue&type=script&lang=ts"
export * from "./EmailVerifiedView.vue?vue&type=script&lang=ts"
import style0 from "./EmailVerifiedView.vue?vue&type=style&index=0&id=3ffef50a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffef50a",
  null
  
)

export default component.exports